<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <div slot="modal-title">
      {{ $t('message.service_item.select') }}
    </div>
    <template v-for="serviceItem, index in serviceItems">
      <div class="card bg-light">
        <div class="card-body p-3">
          <div class="d-flex justify-content-start align-items-center">
            <div>
              <img :src="serviceItem.picture" 
                 width="96" 
                 class="rounded" />
            </div>
            <div class="p-3">
              <div class="text-left"><b>{{ serviceItem | multiLangName }}</b></div>
              <div class="mt-1 text-small text-left">
                <span class="text-secondary" v-if="serviceItem.status === 1">{{ $t('message.service_item.available') }}</span>
                <span class="text-danger" v-else>{{ $t('message.service_item.unavailable') }}</span>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-start align-items-center mt-3 bg-white p-1" v-if="serviceItem.status === 1">
            <div>
              <button class="btn rounded-pill px-4" 
                      :class="[serviceItem.count === 0 ? 'btn-secondary' : 'btn-info']"
                      :disabled="serviceItem.count === 0"
                      @click="decreaseCount(index)">
                <i class="fal fa-minus fa-lg"></i>
              </button>
            </div>
            <div class="flex-fill text-center">
              {{ serviceItem.count }}
            </div>
            <div>
              <button class="btn rounded-pill px-4" 
                      :class="[serviceItem.count === serviceItem.max_qty ? 'btn-secondary' : 'btn-info']"
                      :disabled="serviceItem.count === serviceItem.max_qty"
                      @click="increaseCount(index)">
                <i class="fal fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="p-4 text-secondary text-center" v-if="parentService && parentService.service_items_remark">
      <span v-html="parentService.service_items_remark.remark_th" v-if="$i18n.locale === 'th'"></span>
      <span v-html="parentService.service_items_remark.remark_en" v-else></span>
    </div>

    <hr class="mt-3">
    <div class="d-flex justify-content-start align-items-center modal-footer--sticky bg-white py-2">
      <div class="flex-fill text-left">
        <div>{{ $t('message.booking.summary.price') }} <span class="text-info price-per-hour">{{ totalPrice | currency }}</span></div>
        <div class="text-small">* {{ $t('message.exclude_vat') }}</div>
      </div>
      <div>
        <button class="btn btn-info btn-lg rounded-pill px-4" @click="submit()">
          {{ $t('message.button.submit') }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      SweetModal
    },
    props: {
      parentService: Object
    },
    data () {
      return {
        allServiceItems: [],
        serviceItems: [],
        totalPrice: null
      }
    },
    watch: {
      parentService () {
        // Clear and reset service items
        this.allServiceItems = []
        this.allServiceItems = this.parentService.service_items
        this.serviceItems = []
      }
    },
    methods: {
      showModal (status, provinceId) {
        // Open modal
        this.$refs.modal.open()
        this.provinceId = provinceId
        if (this.serviceItems.length > 0) {
          const index = this.serviceItems.findIndex(item => item.province_id === provinceId)
          if (index === -1) {
            this.initData(provinceId)
          }
        } else {
          this.initData(provinceId)
        }
      },
      closeModal () {
        this.$refs.modal.close()
      },
      initData (provinceId) {
        // Set service items based on province id
        this.serviceItems = []
        this.totalPrice = null
        if (this.allServiceItems) {
          this.allServiceItems.forEach(item => {
            if (item.province_id === provinceId) {
              item.count = 0
              this.serviceItems.push(item)
            }
          })
        }
      },
      clearData () {
        this.serviceItems = []
        this.setTotalPrice()
      },
      decreaseCount (index) {
        this.serviceItems[index].count -= 1
        this.setTotalPrice()
      },
      increaseCount (index) {
        this.serviceItems[index].count += 1
        this.setTotalPrice()
      },
      setTotalPrice () {
        this.totalPrice = 0.0
        this.serviceItems.forEach(item => {
          if (item.cost) {
            const basePrice = item.cost * item.count
            if (item.discount_conditions) {
              const itemCount = item.count
              let hasDiscountCondition = false
              for (const discountCondition of item.discount_conditions) {
                if (itemCount === discountCondition.quantity) {
                  hasDiscountCondition = true
                  let discountCost = (basePrice * discountCondition.discount) / 100
                  discountCost = Math.round(discountCost * 100) / 100
                  this.totalPrice += basePrice - discountCost
                  break
                }
              }
              if (!hasDiscountCondition) {
                this.totalPrice += basePrice
              }
            } else {
              this.totalPrice += basePrice
            }
          }
        })
      },
      submit () {
        let selectedServiceItems = null
        if (this.totalPrice) {
          selectedServiceItems = []
          this.serviceItems.forEach(item => {
            if (item.count) {
              selectedServiceItems.push(item)
            }
          })
        }
        this.$emit('selectServiceItems', selectedServiceItems)
        this.closeModal()
      }
    },
    mounted () {
      this.allServiceItems = this.parentService.service_items
    }
  }
</script>

<style scoped>
.modal-footer--sticky {
  position: sticky;
  bottom: 0;
  background-color: inherit; /* [1] */
  z-index: 1055; /* [2] */
}
</style>


// WEBPACK FOOTER //
// src/components/booking/components/ServiceItemModal.vue